import React, { useEffect } from 'react'
import qs from 'qs'
import { Icon, Toast, useToast } from '@northlight/ui'
import { AlertCircleDuo } from '@northlight/icons'
import { useLocation } from 'react-router-dom'

const LOGIN_FAILED_ERROR_KEY = 'LoginFailed'
const LOGIN_FAILED_MESSAGE = 'Could not log you in. Please try again or contact your administrator.'

export function hasLoginError (search) {
  const { error } = qs.parse(search, { ignoreQueryPrefix: true })

  return error === LOGIN_FAILED_ERROR_KEY
}

export function usePathError () {
  const location = useLocation()
  const toast = useToast()

  function displayLoginFailed () {
    toast({
      position: 'top',
      render: ({ onClose }) => (
        <Toast
          icon={ <Icon as={ AlertCircleDuo } /> }
          variant="error"
          description={ LOGIN_FAILED_MESSAGE }
          onClose={ onClose }
        />
      ),
    })
  }

  useEffect(
    () => {
      if (hasLoginError(location.search)) {
        displayLoginFailed()
      }
    },
    []
  )
}
